import { NoteRoute } from '@/modules/note/v1/api/NoteRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { UploadParams } from '@/modules/note/v1/api/v1/files/Dto/UploadParams'
import { Upload } from '@/modules/note/v1/api/v1/files/Dto/Upload'

/** GET /api/note/v1/uploads/{upload}: сколько байт принято — продолжение после обрыва */
export class GetUploadRoute extends NoteRoute<null, Upload> {
  constructor(private readonly params: UploadParams) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/note/v1/uploads/' + this.params.upload
  }

  offline(): Promise<ApiResponse<Upload>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new Upload({ upload: this.params.upload, size: 0, received: 0, file: null }) }))
  }
}
